<template>
    <div class="grid-view-products-item">
        <ProductCard :product="product" :category="category" />
    </div>
</template>

<script>
import ProductCard from "./../../ProductCard.vue";

export default {
    components: { ProductCard },

    props: ["product", 'category'],
};
</script>
